export const getValueFromObjectValue = (data, valueName) => {
  return Array.isArray(data)
    ? data.map((val) => val[valueName])
    : data[valueName];
};
